import Footer from "./Footer";

export default function Layout({ children }) {
  return (
    <div style={styles.wrapper}>
      <main style={styles.content}>
        {children}
      </main>
      <Footer />
    </div>
  );
}

const styles = {
  wrapper: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
  },
  content: {
    flex: 1,
  },
};
